import * as React from "react";
import { Checkbox as CheckboxBase, CheckboxProps } from "@fluentui/react-northstar";
import bn from "helper/bemnames";
const bem = bn.create("checkbox");
const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps) => {
  return <CheckboxBase {...props} className={bem.b()} />;
};
export default Checkbox;
